<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Pastoral from "../../views/evaluaciones/evaluacion-pastoral";
import Swal from "sweetalert2";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader,Pastoral },
    props:[
        'user_evaluar',
        'tipo_ev',
        'retro'
    ],
    data() {
        return {
            title: "Evaluación Jefe de Departamento",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            encuesta:{
                id:'',
                proceso_usuario_id:'',
                formato_encuesta_id:'',
                p1:'',p2:'',p3:'',p4:'',p5:'',p6:'',p7:'',p8:'',p9:'',p10:'',p11:'',p12:'',p13:'',p14:'',p15:'',p16:'',p17:'',p18:'',p19:'',p20:'',
            },
            plan_mejora:{
                p1:'',p2:'',p3:'',p4:'',p5:'',p6:'',p7:'',p8:'',p9:'',
            },
            pastoral:{
                p1:'',p2:'',p3:'',p4:'',p5:'',p6:'',p7:'',p8:'',
                t1:'',t2:'',
            },
            usuario: '',
            user_a_evaluar: '',
            proceso:'',
            instrumento:'',
            proceso_usuario:'',
            bloquear_guardar:true,
            bloquear_encuesta:true,
        };
    },
    created() {
        this.actualizar()
    },
    methods: {
        actualizar(){
            this.bloquear_encuesta=true
            if (this.retro) {
                let payload={
                    instrumento_id:5,//valor corresponde a id del instrumento correspondiente
                    user_evaluar:this.user_evaluar//valor corresponde a id del instrumento correspondiente
                }
                axios.post('/api/get_encuesta_retro',payload).then(res=>{
                    this.usuario=res.data.user
                        this.user_a_evaluar=res.data.user_a_evaluar
                        this.proceso=res.data.proceso
                        this.instrumento=res.data.instrumento
                        this.proceso_usuario=res.data.proceso_usuario

                        res.data.encuesta?this.encuesta=res.data.encuesta:this.bloquear_encuesta=false;
                        res.data.plan_mejora?this.plan_mejora=res.data.plan_mejora:''
                        res.data.pastoral?this.pastoral=res.data.pastoral:''
                });
            }else{
                let payload={
                    instrumento_id:5,//valor corresponde a id del instrumento correspondiente
                    user_evaluar:this.user_evaluar//valor corresponde a id del instrumento correspondiente
                }
                axios.post('/api/get_encuesta',payload).then(res=>{
                    if(res.data.estado){
                        this.usuario=res.data.user
                        this.user_a_evaluar=res.data.user_a_evaluar
                        this.proceso=res.data.proceso
                        this.instrumento=res.data.instrumento
                        this.proceso_usuario=res.data.proceso_usuario

                        res.data.encuesta?this.encuesta=res.data.encuesta:this.bloquear_encuesta=false//carga encuesta y evaluacion si existe 
                        res.data.plan_mejora?this.plan_mejora=res.data.plan_mejora:''
                        res.data.pastoral?this.pastoral=res.data.pastoral:''

                        this.usuario.rol_id==1?console.log(this.usuario):''
                        console.log(this.proceso?'Proceso '+this.proceso.id:'Sin proceso')
                        console.log(this.instrumento?'Instrumento '+this.instrumento.id:'Sin instrumento')
                        console.log(res.data.encuesta?'Encuesta '+res.data.encuesta.id:'Sin encuesta')
                        console.log(this.tipo_ev?'Tipo_ev '+this.tipo_ev:'Tipo_ev none')
                        if(this.proceso_usuario){
                            this.encuesta.proceso_usuario_id=this.proceso_usuario.id
                            this.encuesta.formato_encuesta_id=this.instrumento.id
                            
                            console.log('Proceso_usuario '+this.proceso_usuario.id)
                        }else{
                            console.log('Sin proceso_usuario')
                            console.log('bloquear encuesta')
                            this.bloquear_guardar=false
                        }
                    }else{
                        console.log('error')
                    }
                });
            }
        },
        guardar(){
            let payload={
                tipo_ev:this.tipo_ev,
                user_a_evaluar:this.user_a_evaluar,
                encuesta:this.encuesta,
                plan_mejora:this.plan_mejora,
                pastoral:this.pastoral
            }
            axios.post('/api/guardar_encuesta', payload).then(res=>{
                if(res.data.estado){
                    //this.$toasted.success(res.data.mensaje);
                    console.log(res.data.mensaje)
                    Swal.fire({
                        title: "Se han guardado tus respuestas con éxito", 
                        //text: "Debe tomar conocimiento sobre los Documentos Institucionales y Reglamentos",
                        icon: "success",
                        confirmButtonColor: "#f1b44c",
                        confirmButtonText: "Aceptar"
                    });
                    this.actualizar()
                    
                }else{
                    //this.$toasted.error(res.data.mensaje);
                    console.log(res.data.mensaje)
                    console.log(res.data.e)
                }
            });
        },
        camposmsg(seccion, text) {
            Swal.fire({
                title: "Faltan campos por completar en: \n\n"+seccion+' ('+text+')',
                //text: text,
                icon: "warning",
                confirmButtonColor: "#f1b44c",
                confirmButtonText: "Volver"
            });
        },
        validaciones(){
            if(this.encuesta.p1==null || this.encuesta.p1=='') {
                this.camposmsg('I.Competencias Funcionales', 'Indicador 1');
                return
            }
            if(this.encuesta.p2==null || this.encuesta.p2=='') {
                this.camposmsg('I.Competencias Funcionales', 'Indicador 2');
                return
            }
            if(this.encuesta.p3==null || this.encuesta.p3=='') {
                this.camposmsg('I.Competencias Funcionales', 'Indicador 3');
                return
            }
            if(this.encuesta.p4==null || this.encuesta.p4=='') {
                this.camposmsg('I.Competencias Funcionales', 'Indicador 4');
                return
            }
            if(this.encuesta.p5==null || this.encuesta.p5=='') {
                this.camposmsg('I.Competencias Funcionales', 'Indicador 5');
                return
            }
            if(this.encuesta.p6==null || this.encuesta.p6=='') {
                this.camposmsg('II.Competencias Conductuales', 'Indicador 1');
                return
            }
            if(this.encuesta.p7==null || this.encuesta.p7=='') {
                this.camposmsg('II.Competencias Conductuales', 'Indicador 2');
                return
            }
            if(this.encuesta.p8==null || this.encuesta.p8=='') {
                this.camposmsg('II.Competencias Conductuales', 'Indicador 3');
                return
            }
            if(this.encuesta.p9==null || this.encuesta.p9=='') {
                this.camposmsg('II.Competencias Conductuales', 'Indicador 4');
                return
            }
            if(this.encuesta.p10==null || this.encuesta.p10=='') {
                this.camposmsg('II.Competencias Conductuales', 'Indicador 5');
                return
            }
            if(this.encuesta.p11==null || this.encuesta.p11=='') {
                this.camposmsg('III.Competencias Cognitivas', 'Indicador 1');
                return
            }
            if(this.encuesta.p12==null || this.encuesta.p12=='') {
                this.camposmsg('III.Competencias Cognitivas', 'Indicador 2');
                return
            }
            if(this.encuesta.p13==null || this.encuesta.p13=='') {
                this.camposmsg('III.Competencias Cognitivas', 'Indicador 3');
                return
            }
            if(this.encuesta.p14==null || this.encuesta.p14=='') {
                this.camposmsg('III.Competencias Cognitivas', 'Indicador 4');
                return
            }
            if(this.encuesta.p15==null || this.encuesta.p15=='') {
                this.camposmsg('III.Competencias Cognitivas', 'Indicador 5');
                return
            }
            if(this.plan_mejora.p1==null || this.plan_mejora.p1=='') {
                this.camposmsg('Plan Mejoras', 'Al menos 1 Fortaleza');
                return
            }
            if(this.plan_mejora.p4==null || this.plan_mejora.p4=='') {
                this.camposmsg('Plan Mejoras', 'Al menos 1 Debilidad');
                return
            }
            if(this.plan_mejora.p7==null || this.plan_mejora.p7=='') {
                this.camposmsg('Plan Mejoras', 'Sugerencia de mejora');
                return
            }
            if (this.user.id==this.user_evaluar.id) {
                if(this.pastoral.p1==null || this.pastoral.p1=='') {
                    this.camposmsg('Pastoral', 'Indice 1');
                    return
                }
                if(this.pastoral.p2==null || this.pastoral.p2=='') {
                    this.camposmsg('Pastoral', 'Indice 2');
                    return
                }
                if(this.pastoral.p3==null || this.pastoral.p3=='') {
                    this.camposmsg('Pastoral', 'Indice 3');
                    return
                }
                if(this.pastoral.p4==null || this.pastoral.p4=='') {
                    this.camposmsg('Pastoral', 'Indice 4');
                    return
                }
                if(this.pastoral.p5==null || this.pastoral.p5=='') {
                    this.camposmsg('Pastoral', 'Indice 5');
                    return
                }
                if(this.pastoral.p6==null || this.pastoral.p6=='') {
                    this.camposmsg('Pastoral', 'Indice 6');
                    return
                }

                if(this.pastoral.t1==null || this.pastoral.t1=='') {
                    this.camposmsg('Pastoral', 'Mis propuestas para la mejora');
                    return
                }
                if(this.pastoral.t2==null || this.pastoral.t2=='') {
                    this.camposmsg('Pastoral', 'Los aspectos donde necesito ayuda');
                    return
                }
            }
            this.guardar()
        }
    },
    computed:{
        total(){
            //funcionales
            let suma1 = Math.round((parseInt(this.encuesta.p1)+ parseInt(this.encuesta.p2)+ parseInt(this.encuesta.p3)+ parseInt(this.encuesta.p4)+ parseInt(this.encuesta.p5))/5);
            let suma2 = Math.round((parseInt(this.encuesta.p6)+ parseInt(this.encuesta.p7)+ parseInt(this.encuesta.p8)+ parseInt(this.encuesta.p9)+ parseInt(this.encuesta.p10))/5);
            let suma3 = Math.round((parseInt(this.encuesta.p11)+ parseInt(this.encuesta.p12)+ parseInt(this.encuesta.p13)+ parseInt(this.encuesta.p14)+ parseInt(this.encuesta.p15))/5);
            return (suma1*0.333+suma2*0.333+suma3*0.333).toFixed(2);
        },
        prom1(){
            let suma1 = Math.round((parseInt(this.encuesta.p1)+ parseInt(this.encuesta.p2)+ parseInt(this.encuesta.p3)+ parseInt(this.encuesta.p4)+ parseInt(this.encuesta.p5))/5);
            return (suma1*0.333).toFixed(2);
        },
        prom2(){
            let suma2 = Math.round((parseInt(this.encuesta.p6)+ parseInt(this.encuesta.p7)+ parseInt(this.encuesta.p8)+ parseInt(this.encuesta.p9)+ parseInt(this.encuesta.p10))/5);
            return (suma2*0.333).toFixed(2);
        },
        prom3(){
            let suma3 = Math.round((parseInt(this.encuesta.p11)+ parseInt(this.encuesta.p12)+ parseInt(this.encuesta.p13)+ parseInt(this.encuesta.p14)+ parseInt(this.encuesta.p15))/5);
            return (suma3*0.333).toFixed(2);
        },
        porc(){
            let suma1 = Math.round((parseInt(this.encuesta.p1)+ parseInt(this.encuesta.p2)+ parseInt(this.encuesta.p3)+ parseInt(this.encuesta.p4)+ parseInt(this.encuesta.p5))/5);
            let suma2 = Math.round((parseInt(this.encuesta.p6)+ parseInt(this.encuesta.p7)+ parseInt(this.encuesta.p8)+ parseInt(this.encuesta.p9)+ parseInt(this.encuesta.p10))/5);
            let suma3 = Math.round((parseInt(this.encuesta.p11)+ parseInt(this.encuesta.p12)+ parseInt(this.encuesta.p13)+ parseInt(this.encuesta.p14)+ parseInt(this.encuesta.p15))/5);
            let suma = suma1*0.333+suma2*0.333+suma3*0.333;
            return ((100*suma)/4).toFixed(2);
        }
    }
};
</script>
<template>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h4>Evaluación Jefe de Departamento</h4>
                        <h5>{{user_evaluar.nombre}} {{user_evaluar.apellidoPaterno}} {{user_evaluar.apellidoMaterno}}</h5>
                        <div class="card bg-soft-primary p-3">
                            <h5>Escala</h5>
                            <div class="table-responsive">
                                <table class="table table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th colspan="2">Puntaje</th>
                                            <th>Tipo conducta</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>Débil</td>
                                            <td>Desempeño débil e incompleto. Hay evidencias de una tarea que está lejos de lo
                                            deseable, lo cual afecta los objetivos institucionales.</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>Incipiente</td>
                                            <td>Desempeño que cumple con el estándar mínimo y donde se manifiestan algunas
                                            debilidades esporádicas.</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>Satisfactorio</td>
                                            <td>Desempeño adecuado y que cumple con las características de calidad esperada para cada indicador.</td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>Avanzado</td>
                                            <td>Desempeño sobresaliente, destacado, tanto por la persistencia en su expresión como
                                            por la profundidad y variedad de expresiones con las cuales se complementa.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="mt-3">
                            <h4>I.Competencias Funcionales</h4>
                            <div class="table-responsive">
                                <table class="table table-bordered table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th>Descripción</th>
                                            <th>Puntaje</th>
                                            <th>%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Lidera y difunde en su Departamento el PEI, de acuerdo con los lineamientos de la Sub-Dirección Curricular y Dirección</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p1">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                            <td rowspan="5">33,3%</td>
                                        </tr>
                                        <tr>
                                            <td>Informa sistemáticamente al Sub-Director Curricular sobre la marcha en el ámbito académico de su área y Departamento</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p2">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Elabora junto a su equipo el Plan Anual del Departamento, asegurando la cobertura curricular de su área y la implementación
                                            de los Programas de estudio en el aula.</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p3">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Apoya e incentiva el buen desempeño pedagógico de su equipo, garantizando la modalidad de trabajo en equipo en su
                                            Departamento</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p4">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Observa clases de los docentes de su Departamento en congruencia con las planificaciones presentadas por l0s docentes y
                                            colabora en su desarrollo humano y profesional.</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p5">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="card bg-soft-primary p-3" v-if="retro">
                            <label class="text-center">Promedio: {{prom1}} corresponde al 33,3%</label>
                        </div>
                        <div class="mt-3">
                            <h4>II.Competencias Conductuales</h4>
                            <div class="table-responsive">
                                <table class="table table-bordered table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th>Descripción</th>
                                            <th>Puntaje</th>
                                            <th>%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><b>Compromiso ético – social cristiano católico:</b>transmite y practica los valores del PEI; evidencia su compromiso con la
                                            institución; Es un modelo para estudiantes y personal del colegio. Mantiene reserva y confidencialidad de la información que
                                            maneja.</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p6">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                            <td rowspan="5">33,3%</td>
                                        </tr>
                                        <tr>
                                            <td><b>Auto aprendizaje e innovación:</b>actualiza su área en capacitaciones y perfeccionamientos; Se compromete con la propia
                                            formación para mejorar la tarea (autoformación); Es creativo y autocrítico; Se adapta a los cambios</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p7">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><b>Liderazgo pedagógico:</b>desarrolla capacidad de compromiso en estudiantes; promueve participación y motivación de
                                            estudiantes; promueve la autodisciplina de estudiantes en aula y en colegio; cree en estudiantes y les comunica altas
                                            expectativas</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p8">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><b>Manejo de crisis:</b>mantiene la calma, observa con objetividad la situación, se contiene emocionalmente, formula alternativas
                                            de solución de problemas y orienta en la búsqueda de apoyo y ayuda cuando se requiere.</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p9">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><b>Responsabilidad:</b>cumple con las actitudes de asistencia y puntualidad; Se compromete con objetivos de trabajos y
                                            proyectos; entrega resultados o productos de su tarea dentro de los plazos.</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p10">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="card bg-soft-primary p-3" v-if="retro">
                            <label class="text-center">Promedio: {{prom2}} corresponde al 33,3%</label>
                        </div>
                        <div class="mt-3">
                            <h4>III.Competencias Cognitivas</h4>
                            <div class="table-responsive">
                                <table class="table table-bordered table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th>Descripción</th>
                                            <th>Puntaje</th>
                                            <th>%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Conoce y administra temáticas técnicas de liderazgo, gestión institucional y planificación estratégica</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p11">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                            <td rowspan="5">33,3%</td>
                                        </tr>
                                        <tr>
                                            <td>Conoce y administra temáticas de gestión curricular y técnico pedagógicas.</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p12">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Conoce y aplica la normativa vigente relacionada con la vulneración de derechos de niños, niñas y adolescentes</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p13">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Conoce y procede conforme al Reglamento Interno de Convivencia Escolar (RICE), Modelo Pedagógico MSC, Reglamento
                                            de Evaluación y Reglamento Interno de Orden, Higiene y Seguridad (RIOHS) en los ámbitos de su acción</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p14">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Conoce y administra recursos tecnológicos para la administración y/o la enseñanza</td>
                                            <td>
                                                <select class="custom-select" :disabled="bloquear_encuesta" v-model="encuesta.p15">
                                                    <option value="" disabled>Seleccione un Puntaje</option>
                                                    <option value="1">1 Débil</option>
                                                    <option value="2">2 Incipiente</option>
                                                    <option value="3">3 Satisfactorio</option>
                                                    <option value="4">4 Avanzado</option>
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="card bg-soft-primary p-3" v-if="retro">
                            <label class="text-center">Promedio: {{prom3}} corresponde al 33,3%</label>
                        </div>
                        <div class="card bg-primary p-3 mt-3" v-if="retro">
                            <h4 class="text-center text-white">Total Evaluación de Desempeño: {{total}} corresponde al {{porc}}%</h4>
                        </div>
                        <div class="mt-3">
                            <h4>PLAN DE MEJORA DEL DESEMPEÑO PROFESIONAL AUTOEVALUACIÓN/COEVALUACIÓN</h4>
                            <label>Especificar solo los aspectos más relevantes de mi práctica pedagógica. (Máximo 3)</label>
                            <div class="row bg-soft-primary p-3">
                                <div class="col-md-12 mb-3">
                                    <label>Fortalezas</label>
                                    <div class="row">
                                        <b-form-textarea class="col-md-4" id="textarea" :disabled="bloquear_encuesta" v-model="plan_mejora.p1" placeholder="Ingresar primero" rows="3" max-rows="6"></b-form-textarea>
                                        <b-form-textarea class="col-md-4" id="textarea" :disabled="bloquear_encuesta" v-model="plan_mejora.p2" placeholder="Ingresar segundo" rows="3" max-rows="6"></b-form-textarea>
                                        <b-form-textarea class="col-md-4" id="textarea" :disabled="bloquear_encuesta" v-model="plan_mejora.p3" placeholder="Ingresar tercero" rows="3" max-rows="6"></b-form-textarea>
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label>Debilidades</label>
                                    <div class="row">
                                        <b-form-textarea class="col-md-4" id="textarea" :disabled="bloquear_encuesta" v-model="plan_mejora.p4" placeholder="Ingresar primero" rows="3" max-rows="6"></b-form-textarea>
                                        <b-form-textarea class="col-md-4" id="textarea" :disabled="bloquear_encuesta" v-model="plan_mejora.p5" placeholder="Ingresar segundo" rows="3" max-rows="6"></b-form-textarea>
                                        <b-form-textarea class="col-md-4" id="textarea" :disabled="bloquear_encuesta" v-model="plan_mejora.p6" placeholder="Ingresar tercero" rows="3" max-rows="6"></b-form-textarea>
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label>Sugerencia de mejora</label>
                                    <div class="row">
                                        <b-form-textarea class="col-md-4" id="textarea" :disabled="bloquear_encuesta" v-model="plan_mejora.p7" placeholder="Ingresar primero" rows="3" max-rows="6"></b-form-textarea>
                                        <b-form-textarea class="col-md-4" id="textarea" :disabled="bloquear_encuesta" v-model="plan_mejora.p8" placeholder="Ingresar segundo" rows="3" max-rows="6"></b-form-textarea>
                                        <b-form-textarea class="col-md-4" id="textarea" :disabled="bloquear_encuesta" v-model="plan_mejora.p9" placeholder="Ingresar tercero" rows="3" max-rows="6"></b-form-textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Pastoral v-if="(user.id==user_evaluar.id || retro)" :pastoral="pastoral" :bloquear_encuesta="bloquear_encuesta"/>
                        <b-button size="sm" variant="primary" @click="validaciones()" v-if="(!bloquear_encuesta || !retro)">Guardar</b-button>
                    </div>
                </div>
            </div>
        </div>
</template>